import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-2 flex w-full flex-col-reverse items-center justify-center gap-6 md:mt-8.5 md:flex-row md:gap-11.5',
    more: 'w-full flex-1 tracking-[0.9px] md:max-w-[232px]',
    pagination: 'flex items-center justify-center',
    ellipsis:
      'flex h-10 w-10 items-center justify-center md:h-[50px] md:w-[50px]'
  }
});
